"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Constants = require("../../00_environment/Constants");

var _Button = _interopRequireDefault(require("../../01_atoms/Button"));

var _Bottom = _interopRequireDefault(require("../../01_atoms/Bottom"));

var _Container = _interopRequireDefault(require("../../01_atoms/Container"));

var _Element = _interopRequireDefault(require("../../01_atoms/Element"));

var _ElementGroup = _interopRequireDefault(require("../../01_atoms/ElementGroup"));

var _BlockWithLeftIcon = _interopRequireDefault(require("../../01_atoms/BlockWithLeftIcon"));

var _PopupScreen = _interopRequireDefault(require("../../02_molecules/PopupScreen"));

var _TitledContainer = _interopRequireDefault(require("../../01_atoms/TitledContainer"));

var _ResponsiveCentralPaneWrapper = _interopRequireDefault(require("../../02_molecules/ResponsiveCentralPaneWrapper"));

var _tick = _interopRequireDefault(require("../../../assets/tick.svg"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var SignUpOkPageUI = function SignUpOkPageUI(_ref) {
  var nextLabel = _ref.nextLabel,
      nextLink = _ref.nextLink,
      translatorForNamespace = _ref.translatorForNamespace;
  var t = translatorForNamespace('SignUpOkPageUI');
  return /*#__PURE__*/_react["default"].createElement(_PopupScreen["default"], {
    title: t('Sign up')
  }, /*#__PURE__*/_react["default"].createElement(_ResponsiveCentralPaneWrapper["default"], null, /*#__PURE__*/_react["default"].createElement(_TitledContainer["default"], {
    title: t('Sign up')
  }, /*#__PURE__*/_react["default"].createElement(_ElementGroup["default"], {
    title: t('Account created')
  }, /*#__PURE__*/_react["default"].createElement(_Element["default"], null, /*#__PURE__*/_react["default"].createElement(_BlockWithLeftIcon["default"], {
    icon: _tick["default"]
  }, /*#__PURE__*/_react["default"].createElement("strong", null, t('Welcome to {appName}!', {
    appName: _Constants.appName
  })), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("br", null), t('Your account has been created successfully.'), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("br", null), t('Start ordering your bus tickets right now!')))), /*#__PURE__*/_react["default"].createElement(_Bottom["default"], null, /*#__PURE__*/_react["default"].createElement(_Container["default"], null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
    to: nextLink,
    primary: true,
    fluid: true
  }, nextLabel))))));
};

var _default = SignUpOkPageUI;
exports["default"] = _default;